const key = userId => `timely-sidebar:${userId}`;

export function readSidebarExpanded(userId) {
  if (!userId) return true;
  try { return localStorage.getItem(key(userId)) !== 'collapsed'; }
  catch { return true; }
}

export function saveSidebarExpanded(userId, expanded) {
  if (!userId) return;
  try { localStorage.setItem(key(userId), expanded ? 'expanded' : 'collapsed'); }
  catch { /* Keep the menu usable when browser storage is unavailable. */ }
}
